import React from "react";
import PropTypes from "prop-types";
import * as d3Axis from "d3-axis";
import { format } from "d3-format";
import { select } from "d3-selection";
import withResponsiveContainer from "./withResponsiveContainer";

class Axis extends React.Component {
  constructor() {
    super();
    this.gRef = React.createRef();
  }

  componentDidMount() {
    this.d3Render();
  }

  componentDidUpdate() {
    this.d3Render();
  }

  d3Render() {
    const {
      type,
      scale,
      width,
      marginLeft,
      marginRight,
      customTickValues,
    } = this.props;
    const adjustedWidth = width - (marginLeft + marginRight);
    scale.range([0, adjustedWidth]);
    const callableAxis = d3Axis[`axis${type}`](scale).tickFormat(format("d"));
    if (customTickValues) {
      callableAxis.tickValues(customTickValues);
    }
    // const callableAxis = d3Axis[`axis${type}`](scale);

    select(this.gRef.current).call(callableAxis);
  }

  render() {
    const { marginLeft, height } = this.props;

    return (
      <g
        ref={this.gRef}
        transform={`translate(${marginLeft}, ${height})`}
        className="range-slider__axis"
      />
    );
  }
}

const ResponsiveAxis = withResponsiveContainer(Axis, {
  height: 20,
  margin: { top: 0, bottom: 0, right: 0, left: 0 },
});

Axis.propTypes = {
  type: PropTypes.string.isRequired,
  scale: PropTypes.func.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  marginLeft: PropTypes.number.isRequired,
  marginRight: PropTypes.number.isRequired,
};

export default ResponsiveAxis;
